import React from "react";
import useAddAppointment from "../../../hooks/appoitnment/useAddAppointment";

import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
import AlertMessage from "../../../components/AlertMessage";
import "bootstrap/dist/css/bootstrap.min.css";
import Accordion from "./Accordion";
import TimeSlotPicker from "./TimeSlotPicker";
import Breadcrumb from "../../../components/Breadcrumb";

const AddAppointment = () => {
  const {
    staffId,
    setStaffId,
    barbers,
    customers,
    selectedCustomer,
    setSelectedCustomer,
    date,
    setDate,
    selectedTime,
    setSelectedTime,
    handleServiceChange,
    handleServiceQuantityChange,
    selectedServices,
    handleSubmit,
    message,
    showMessage,
    setShowMessage,
    totalPrice,
    totalTime,
    timeSlotList,
    availableServiceList,
  } = useAddAppointment();
  if (!customers || !barbers) return <h2>Loading...</h2>;

  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Appointments" child="Add Appointment" />
        {showMessage && (
          <AlertMessage
            key={message.text}
            setVisible={setShowMessage}
            message={message.text}
            type={message.type}
            duration={4000}
          />
        )}
        <div className="card">
          <div className="row m-3">
            <div className="col-4 form-control-container ">
              <label htmlFor="tva" className="form-label form-control-label">
                Client
              </label>
              <Combobox
                onChange={(value) => setSelectedCustomer(value)}
                data={customers}
                dataKey="id"
                textField="name"
                value={selectedCustomer}
                containerClassName={" form-combobox"}
              />
            </div>
            <div className="col-4 form-control-container ">
              <label htmlFor="tva" className="form-label form-control-label">
                Barber
              </label>
              <Combobox
                onChange={(value) => setStaffId(value.id)}
                data={barbers}
                dataKey="id"
                textField="name"
                value={staffId}
                defaultValue={staffId}
                containerClassName={" form-combobox"}
              />
            </div>
            <div className="col-4 form-control-container ">
              <label htmlFor="tva" className="form-label form-control-label">
                Date
              </label>
              <input
                type="date"
                className="form-control form-input"
                value={date}
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="col-8 form-control-container ">
              <Accordion
                servicesGroup={availableServiceList}
                selectedServices={selectedServices}
                onSelectService={handleServiceChange}
                handleQuantityChange={handleServiceQuantityChange}
              />
            </div>
            <div className="col-2 form-control-container">
              <span>Total time: {totalTime}</span>
            </div>
            <div className="col-2 form-control-container ">
              Total Price: {totalPrice}
            </div>
            <div className="col-12 form-control-container ">
              {timeSlotList.length > 0 && (
                <TimeSlotPicker
                  times={timeSlotList}
                  setSelectedTime={setSelectedTime}
                  selectedTime={selectedTime}
                />
              )}
            </div>
            <div className="col-12 form-control-container ">
              <button
                type="submit"
                className=" btn btn-primary text-white px-4 py-2 rounded-5 ms-auto"
                onClick={handleSubmit}
                disabled={totalTime === 0}
              >
                Submit
              </button>
            </div>{" "}
          </div>{" "}
        </div>
      </div>
    </div>
  );
};
export default AddAppointment;
